

import { useState } from 'react'
import { gql, useMutation } from '@apollo/client';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { formatDateForBirth } from "../../dates";

import { ResponsiveContainer } from '../ResponsiveContainer';
import { PersonIdPicker } from './PersonIdPicker'

import {
  Container,
  Header,
  Button,
  Segment,
  Form,
  FormInput,
  FormField,
  Radio,
  FormCheckbox,
} from 'semantic-ui-react'
import { useNavigate } from 'react-router-dom';

const CREATE_PERSON = gql`
mutation AdminCreateUser($name: String!, $picturePermission: Boolean!, $address: String, $scriptName: String, $identifier: String, $tagIds: [Int!], $sex: Int, $phone: String, $dob: String) {
  adminCreateUser(name: $name, picturePermission: $picturePermission, address: $address, scriptName: $scriptName, identifier: $identifier, tagIds: $tagIds, sex: $sex, phone: $phone, dob: $dob) {
      id
  }
}`;

const BIOLOGICAL_SEX_ISO_CODES = [
    { key: 0, text: 'Unknown', value: 0 },
    { key: 1, text: 'Male', value: 1 },
    { key: 2, text: 'Female', value: 2 },
    { key: 9, text: 'N/A', value: 9 },
]

const PersonCreator = () => {

    // Add option picker for sex (unknown 0, male 1, female 2, NA 9)
    const [name, setName] = useState("");
    const [sex, setSex] = useState(0);
    const [address, setAddress] = useState("");
    const [scriptName, setScriptName] = useState("");
    const [phone, setPhone] = useState("");
    const [identifier, setIdentifier] = useState("");
    const [tagIds, setTagIds] = useState<number[]>([]);
    const [picturePermission, setPicturePermission] = useState(false);
    const [dob, setDob] = useState<Date | null>(null);
    const [graphqlDob, setGraphqlDob] = useState<string | "">("");
    const [showErrors, setShowErrors] = useState(false);
    const [createPersonMutation] = useMutation(CREATE_PERSON);
    const navigate = useNavigate()

    const handleSave = async () => {
        if (name && address && graphqlDob && identifier) {
            const user = await createPersonMutation({ variables: {
                name,
                address,
                scriptName,
                identifier,
                sex,
                tagIds,
                phone,
                dob: graphqlDob,
                picturePermission,
            }});

            navigate(`/people/${user.data.adminCreateUser.id}`);
        } else {
            setShowErrors(true);
        }
    }

  return (
    <ResponsiveContainer>
      <Segment style={{ padding: '2em 0em' }} vertical>
        <Container>
            <Header as='h1'>Add person</Header>
            <Form>
                <b>Identifier: {identifier === "" ? "(This automatically allocated)" : identifier}</b>
                <br/>
                <PersonIdPicker
                    setId={setIdentifier}
                    setTagIds={setTagIds}
                    showErrors={showErrors}
                />
                <FormInput
                    error={showErrors && name.length < 1 && 'Please enter a name'}
                    fluid
                    label='Name'
                    placeholder='Name'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                    { /* Add sex option picker*/ }
                <FormInput>
                    <div>
                        {BIOLOGICAL_SEX_ISO_CODES.map((option) => {
                            return (
                                <FormField key={option.key}>
                                    <Radio
                                        label={option.text}
                                        name='sexRadioGroup'
                                        value={option.value.toString()}
                                        checked={sex === option.value}
                                        onChange={() => setSex(option.value)}
                                    />
                                </FormField>
                            )
                        })}
                    </div>
                </FormInput>
                 <FormInput
                    fluid
                    error={showErrors && graphqlDob.length < 1 && 'Please enter a date of birth'}
                    label='Date of birth'
                >
                    <DatePicker
                        selected={dob}
                        dateFormat="dd/MM/yyyy"
                        onChange={(date) => {
                            setGraphqlDob(date != null ? formatDateForBirth(date?.getTime()) : "")
                            setDob(date);
                        }}
                        showYearDropdown
                        maxDate={new Date()}
                    />
                </FormInput>
                <FormInput
                    fluid
                    label='Name in Bengali'
                    placeholder=''
                    value={scriptName}
                    onChange={(e) => setScriptName(e.target.value)}
                />
                <FormInput
                    fluid
                    label='Phone'
                    placeholder='Phone number'
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                />
                <FormInput
                    error={showErrors && address.length < 1 && 'Please enter an address'}
                    fluid
                    label='Address'
                    placeholder='Address'
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                />
                <FormCheckbox
                    fluid
                    label='Picture permission'
                    checked={picturePermission}
                    onChange={() => setPicturePermission(!picturePermission)}
                />
                <Button
                    disabled={!(name && address && graphqlDob && identifier)}
                    onClick={() => handleSave()}>
                    Save
                </Button>
            </Form>
        </Container>
      </Segment>
    </ResponsiveContainer>
  )
}

export { PersonCreator }
